// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\NotificationSearchResponse

import { hydrateNotification, type Notification, type NotificationApiResponse } from './notification.gen';

export type NotificationSearchApiResponse = {
	items: NotificationApiResponse[];
};

export type NotificationSearch = {
	items: Notification[];
};

export function hydrateNotificationSearch(data: NotificationSearchApiResponse): NotificationSearch {
	return {
		...data,
		items: data.items.map(hydrateNotification),
	};
}